export { default as TrashSolidIcon } from './TrashSolidIcon';
